import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Title, Item } from '../index';
import { toVw, toVwMobile, toVwTablet } from '../../../../../utils/styles';
import mq from '@/utils/media-queries';

const CONTENT_WIDTH = 503;

const Content = styled.div`
  width: ${toVw(CONTENT_WIDTH)};

  ${mq.tablet(css`
    width: ${toVwTablet(CONTENT_WIDTH)};
  `)};

  ${mq.mobile(css`
    width: ${toVwMobile(CONTENT_WIDTH)};
  `)};
`;

const DutiesApplicant = ({ className, duties }) => (
  <div className={className}>
    <Title>От тебя</Title>
    <Content>
      {duties.map((item, index) => (
        <Item key={index}>{item}</Item>
      ))}
    </Content>
  </div>
);

DutiesApplicant.propTypes = {
  className: PropTypes.string,
  duties: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DutiesApplicant;



// WEBPACK FOOTER //
// ./src/scenes/Vacancy/components/Duties/components/DutiesApplicant.js